import React from 'react';
import './ViewSwitcher.css';

const ViewSwitcher = ({ modes = [], value, onChange, color = '#be1622' }) => (
  <div className="vs-switcher">
    {modes.map((m) => (
      <div
        key={m.key}
        role="button"
        tabIndex={0}
        className={`vs-btn${value === m.key ? ' vs-btn--active' : ''}`}
        style={value === m.key ? { '--vs-active-color': color } : undefined}
        onClick={() => onChange(m.key)}
        onKeyDown={(e) => e.key === 'Enter' && onChange(m.key)}
      >
        {m.label}
      </div>
    ))}
  </div>
);

export default ViewSwitcher;